import { Component } from '@angular/core';
import { LoggerService } from './logger.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'HCM Shell';
  constructor(private router: Router) {
    this.router.navigateByUrl('home');
  }

  ngOnInit() {
  }
}
